import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      flexDirection: 'row',
      height: 50,
      paddingLeft: 25,
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    groupName: {
      color: theme.palette.themePrimary,
    },

    groupSelected: {
      backgroundColor: theme.palette.neutralLighter,
    },
  };
});
